

// import { FETCH_INVENTORY, ADD_INVENTORY, UPDATE_INVENTORY, DELETE_INVENTORY } from '../constants/actionTypes';

// const initialState = {
//   list: [],
// };

// const inventory = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_INVENTORY:
//       return {
//         ...state,
//         list: action.payload || [],
//       };

//     case ADD_INVENTORY:
//       // append new item (assumes API returns created doc)
//       return {
//         ...state,
//         list: [action.payload, ...(state.list || [])],
//       };

//     case UPDATE_INVENTORY:
//       // replace the edited item by _id
//       return {
//         ...state,
//         list: (state.list || []).map((item) =>
//           item._id === action.payload._id ? action.payload : item
//         ),
//       };

//       case DELETE_INVENTORY:
//       return {
//         ...state,
//         list: (state.list || []).filter((item) => item._id !== action.payload),
//       };


//     default:
//       return state;
//   }
// };

// export default inventory;


import {
  FETCH_INVENTORY,
  ADD_INVENTORY,
  UPDATE_INVENTORY,
  DELETE_INVENTORY,
} from '../constants/actionTypes';

const initialState = {
  list: [],
};

const inventory = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVENTORY: {
      // Only replace list if payload is a valid array.
      // If payload is missing/invalid, keep the existing list (prevents loops).
      if (!Array.isArray(action.payload)) return state;

      // If the exact same array reference is passed, don’t update state.
      if (action.payload === state.list) return state;

      return {
        ...state,
        list: action.payload,
      };
    }

    case ADD_INVENTORY: {
      // Ignore invalid payloads safely
      if (!action.payload) return state;

      // Optional: avoid duplicating exact same _id if it already exists
      const exists = state.list.some((x) => x?._id === action.payload?._id);
      if (exists) return state;

      return {
        ...state,
        list: [action.payload, ...state.list],
      };
    }

    case UPDATE_INVENTORY: {
      if (!action.payload || !action.payload._id) return state;

      let changed = false;

      const nextList = state.list.map((item) => {
        if (item?._id === action.payload._id) {
          changed = true;
          return action.payload;
        }
        return item;
      });

      // If nothing matched, don’t create a new list/state
      if (!changed) return state;

      return {
        ...state,
        list: nextList,
      };
    }

    case DELETE_INVENTORY: {
      const idToDelete = action.payload;
      if (!idToDelete) return state;

      const nextList = state.list.filter((item) => item?._id !== idToDelete);

      // If length didn’t change, nothing was removed → no state update
      if (nextList.length === state.list.length) return state;

      return {
        ...state,
        list: nextList,
      };
    }

    default:
      return state;
  }
};

export default inventory;
